kv.controller('expenseCategoryEditCtrl', function ($uibModalInstance, data, $injector, $scope) {

	return new dictionaryEditCtrl($uibModalInstance, data, $injector, $scope, {
		entity: "expense_category",
		primaryKey: "expense_category_id",
		newEntity:{
		},
		prepareDataToSave: function () {
			let cmdate = this.getInjection('cmdate');
			let dataToSend = angular.copy(this.data);
			dataToSend.date = cmdate.toServer(this.data.date);
			return dataToSend;
		}
	});
});